import { all, put, call, takeLatest, select, delay } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import API from 'api';
import { actionCreators } from 'store/creditsHistory/actions';

import { messages } from '../../i18n';
import { logout } from '../user/actions';
import { nativeMessageService } from '../../services/NativeMessageService';
import { AppState, DroppingErrorStatus } from '../interfaces';

import { data } from './testData';

const isDebug = false;
const limit = 60;

interface CreditSearchParams {
  limit: number;
  id?: number;
}

function* getCreditsHistory({ payload }) {
  const { isRefreshing } = payload;
  const credits = yield select((app: AppState) => app.creditsHistory.credits);

  const params: CreditSearchParams = { limit };
  const lastId = credits[credits.length - 1]?.id;

  if (!isRefreshing && lastId) {
    params.id = lastId;
  }

  let response;
  if (isDebug) {
    yield delay(200);
    let startIdx = 0;
    if (params.id) {
      startIdx = data.findIndex((item) => item.id === params.id);
      if (startIdx !== -1) {
        startIdx += 1;
      }
    }
    const items = data.slice(startIdx, startIdx + limit + 1);
    response = {
      code: 200,
      items,
    };
  } else {
    response = yield call(API.purchases.list, params);
  }

  switch (response.code) {
    case 200: {
      const hasNextPage = response.items?.length > limit;
      yield put(
        actionCreators.getCreditsHistory.success(
          isRefreshing ? response.items : [...credits, ...response.items.slice(1)],
          hasNextPage
        )
      );
      break;
    }
    case 401: {
      toast.error(messages.sessionTimeout);
      yield put(logout());
      break;
    }
    default: {
      yield put(actionCreators.getCreditsHistory.failure());
      console.log(response);
    }
  }
}

function* dropRideRequest({ payload }) {
  const { ride } = payload;

  if (ride.pickup_time < +new Date()) {
    yield put(
      actionCreators.dropRide.fulfill(
        {
          error_code: DroppingErrorStatus.TooLateForSkipping,
        },
        ride.id
      )
    );
    return;
  }

  yield nativeMessageService.sendDropRideMessage(ride.id, ride.provider_ride_id);
}

export default function* flow() {
  yield all([
    takeLatest(actionCreators.getCreditsHistory.REQUEST, getCreditsHistory),
    takeLatest(actionCreators.dropRide.REQUEST, dropRideRequest),
  ]);
}
